import React, { useState, useEffect, useContext } from 'react';
import {
    Box,
    Typography,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    TablePagination,
} from '@mui/material';
import { Link, useLocation, useParams } from 'react-router-dom';
import { getReportsByExtraction, Report } from '../../../services/stixify_api.ts';
import { useAlert } from '../../../contexts/alert-context.tsx';
import { URLS } from '../../../services/urls.ts';
import { TeamRouteContext } from '../../team-layout.tsx/index.tsx';
import { TeamContext } from '../../../contexts/team-context.tsx';
import Markdown from 'react-markdown';
import { getDateString } from '../../../services/utils.ts';


const ExtractionReportsPage: React.FC = () => {
    const { teamId } = useContext(TeamRouteContext)
    const { objectId } = useParams<{ objectId: string }>()
    const [reportData, setReportData] = useState<Report[]>([])
    const [loading, setLoading] = useState<boolean>(false);
    const [value, setValue] = useState('');
    const [type, setType] = useState('');
    const [initialDataLoaded, setInitialDataLoaded] = useState(false)
    const location = useLocation();
    const { activeTeam } = useContext(TeamContext)
    const [disableViewPost, setDisableViewPost] = useState(false)
    const [page, setPage] = useState<number>(0); // Current page
    const [pageSize, setPageSize] = useState<number>(10); // Profiles per page
    const [dataCount, setDataCount] = useState<number>(0); // Total number of pages

    const alert = useAlert()

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        setValue(query.get('value') || '')
        setType(query.get('type') || '')
        setInitialDataLoaded(true)
    }, [location])

    useEffect(() => {
        if (!activeTeam) return
        if (!activeTeam.has_active_subscription) {
            setDisableViewPost(true)
        }
    }, [activeTeam])

    useEffect(() => {
        if (initialDataLoaded) loadReports()
    }, [initialDataLoaded])

    const loadReports = async () => {
        if (!objectId) return
        setLoading(true)
        const res = await getReportsByExtraction(teamId || '', objectId, page + 1)
        setReportData(res.data.reports)
        setDataCount(res.data.total_results_count);
        setPageSize(res.data.page_size)
        setLoading(false)
    }

    useEffect(() => { loadReports() }, [page])

    useEffect(() => {
        document.title = 'Observable Reports | Stixify Web'
    }, [])


    const handlePageChange = (event: unknown, value: number) => {
        setPage(value); // Set new page number
    };

    const handleSortChange = (field: string) => { }

    const getReportDetailUrl = (report: Report) => {
        return URLS.teamReportDetail(activeTeam?.id, report.id)
    }

    return (
        <Box p={4}>
            <Typography variant="h4" gutterBottom>
                Observable Reports
            </Typography>
            <Typography>List of posts for the object {type}|{value}</Typography>
            {loading ? (
                <CircularProgress style={{ display: 'block', margin: '20px auto' }} />
            ) : (
                <>
                    <TableContainer sx={{ marginTop: '2rem' }}>
                        <Table>
                            <TableHead>
                                <TableCell onClick={() => handleSortChange('name')} style={{ cursor: 'pointer' }}>            Report Title
                                    {/* {sortField === 'name' ? (sortOrder === 'asc' ? '↑' : '↓') : ''} */}
                                </TableCell>
                                <TableCell>Owned by this Team</TableCell>
                                <TableCell>Report created</TableCell>
                                <TableCell onClick={() => handleSortChange('tlp_level')} style={{ cursor: 'pointer' }}>            TLP Level
                                    {/* {sortField === 'tlp_level' ? (sortOrder === 'asc' ? '↑' : '↓') : ''} */}
                                </TableCell>
                                <TableCell onClick={() => handleSortChange('confidence')} style={{ cursor: 'pointer' }}>            TLP Level
                                    Confidence score
                                    {/* {sortField === 'confidence' ? (sortOrder === 'asc' ? '↑' : '↓') : ''} */}
                                </TableCell>
                                <TableCell>Created By </TableCell>
                                <TableCell>Labels</TableCell>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    <TableRow>
                                        <TableCell colSpan={6}>
                                            <CircularProgress style={{ display: 'block', margin: '20px auto' }} />
                                        </TableCell>
                                    </TableRow>
                                ) : (<>
                                    {reportData.map((report) => (
                                        <TableRow key={report.id}>
                                            <TableCell>
                                                <Link to={getReportDetailUrl(report)}>{report.stixify_file_metadata.name}</Link></TableCell>
                                            <TableCell>{report.team_id == activeTeam?.id ? 'True' : 'False'}</TableCell>
                                            <TableCell>{getDateString(report?.created_at || '')}</TableCell>
                                            <TableCell>
                                                {report.stixify_file_metadata.tlp_level}
                                            </TableCell>
                                            <TableCell>
                                                {report.stixify_file_metadata.confidence}
                                            </TableCell>
                                            <TableCell>{report.stixify_file_metadata.identity.id}</TableCell>
                                            <TableCell>{report.stixify_file_metadata.labels?.join(',')}</TableCell>
                                        </TableRow>
                                    ))}
                                </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* Pagination controls */}
                    <TablePagination
                        component="div"
                        count={dataCount}
                        page={page}
                        rowsPerPage={pageSize}
                        onPageChange={handlePageChange}
                        color="primary"
                        rowsPerPageOptions={[]}
                        labelRowsPerPage={""} // Hide the rows per page label
                        style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}
                    />
                </>
            )
            }
        </Box >
    );
};

export default ExtractionReportsPage;